import * as React from 'react';
import { Spinner } from './Spinner';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { DataStore, TranslationStore, AccessibilityStore } from '../stores';
import { getLabel } from '../utils/getLabel';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { computed } from 'mobx';
import { Theme } from '../models/Theme';
import HeaderButton from './HeaderButton';

const DownloadButtonIcon = styled<any, any>(
    Icon,
    'downloadButtonIcon',
    'explorerDownload'
)`
    flex-shrink: 0;
    height: 1.6em;
    width: 1.6em;
`;

DownloadButtonIcon.defaultProps = {
    marginX: 'sm',
};

const ButtonText = styled<any, any>('span', 'buttonText', 'explorerDownload')`
    ${propStyles};
`;

ButtonText.defaultProps = {
    display: ['inline'],
};

interface ExplorerDownloadProps {
    theme?: Theme;
    dataStore?: DataStore;
    translationStore?: TranslationStore;
    disabled?: boolean;
    accessibilityStore?: AccessibilityStore;
}

@inject('accessibilityStore', 'dataStore', 'translationStore')
@observer
class ExplorerDownload extends React.Component<ExplorerDownloadProps> {
    @computed
    get hasMinimumFiltersNeeded() {
        const { dataStore } = this.props;
        return dataStore.hasMinimumFiltersNeeded();
    }

    render() {
        const {
            theme,
            dataStore,
            translationStore,
            disabled,
            accessibilityStore,
        } = this.props;
        const downloadConfig =
            dataStore &&
            dataStore.config &&
            dataStore.config.explorer &&
            dataStore.config.explorer.download;
        if (
            !downloadConfig ||
            !downloadConfig.enabled ||
            !this.hasMinimumFiltersNeeded
        ) {
            return null;
        }
        const label = getLabel(downloadConfig.label, 'Download');
        const iconFileName =
            downloadConfig.iconFileName || 'ExplorerDownloadIcon';
        let hideChild = downloadConfig.hideChild || 'none';
        if (dataStore && dataStore.isMobile) {
            hideChild = downloadConfig.hideChildMobile || 'text';
        }

        if (
            dataStore &&
            dataStore.stores &&
            dataStore.stores.loading &&
            dataStore.stores.loading.isExplorerDownloadLoading
        ) {
            return (
                <Spinner
                    color="primary"
                    iconSize="sm"
                    {...dataStore.theme.ExplorerDownloadSpinner}
                />
            );
        }

        return (
            <HeaderButton
                aria-label={accessibilityStore.buttonAccessibilityValue(
                    'ExplorerDownloadButton'
                )}
                title={translate(translationStore, label)}
                onClick={dataStore.downloadTable}
                disabled={disabled}
                data-metric-id={'explorerDownload'}
                data-metrics-link-type={'download'}
                // Hard coding the filename as the actual file name is generated on click.
                // This is only used for metric tracking...
                data-metrics-link-dest={'downloadTable.csv'}
                {...theme.ExplorerDownloadButton}
            >
                {hideChild !== 'text' && (
                    <ButtonText>
                        {label && <Translate>{label}</Translate>}
                    </ButtonText>
                )}
                {hideChild !== 'icon' && (
                    <DownloadButtonIcon
                        fileName={iconFileName}
                        {...theme.ExplorerDownloadButtonIcon}
                    />
                )}
            </HeaderButton>
        );
    }
}

export default withTheme(ExplorerDownload) as any;



// WEBPACK FOOTER //
// ./src/Components/ExplorerDownload.tsx